import Vue from 'vue';
import Vuex from 'vuex';
Vue.use(Vuex); // 回头试试删掉这个好使不
import { BlogApi } from '../utils/api/blog.api';
// import { globalInfo } from '../environment'
// import { SessionStorageUtils } from '../utils/session-storage.utils'
import { IS_ADMIN, HOME_URL, USER_INFO } from './mutation-types';

const state = {
  // userId: SessionStorageUtils.getCookie('weixin.xc.user'),
  isLogin: false,
  isAdmin: false,
  homeUrl: false,
  userInfo: {},
};

const getters = {};

const actions = {
  /* 获取权限列表 */
  async getUserlevel({ commit }) {
    let info = await BlogApi.getUserlevel();
    // * 2 普通作者
    // * 10 管理员
    if (info.data == 10) {
      commit(IS_ADMIN, true);
    }
    if (info.attach.url) {
      commit(HOME_URL, info.attach.url);
    }
    // commit(USER_INFO, res.data)
  },
  // 获取用户信息
  async getUserInfo({ commit }, uid) {
    let info = await BlogApi.searchAuthor({
      id: uid,
    });
    console.log(info);
    commit(USER_INFO, info.data);
  },
};

const mutations = {
  [USER_INFO](state, payload) {
    state.userInfo = payload;
  },
  [IS_ADMIN](state, payload) {
    state.isAdmin = payload;
  },
  [HOME_URL](state, payload) {
    state.homeUrl = payload;
  },
};

export var store = new Vuex.Store({
  state,
  getters,
  actions,
  mutations,
});
